import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-toolbar-app',
    templateUrl: './toolbar-app.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiToolbarAppComponent {

    @HostBinding() class = 'eui-toolbar-app';

    @Input() appName: string;

    constructor(
    ) {}
}
